/**
 * Use this to assert that a codepath is not reachable. If the line that calls
 * this code shows a TS error, it means the codepath is reachable (i.e. missing
 * switch case)
 */
export const assertUnreachable = (arg: never): never => {
	throw new Error(`Code should not be reachable ${arg}`);
};
